





import { Vue, Component, Prop } from 'vue-property-decorator'
import { picasso } from '@vechain/picasso'

@Component
export default class Ident extends Vue {
    @Prop(String) private value!: string

    get styleObject() {
        const text = this.value || ''
        let svg = svgCache.get(text)
        if (!svg) {
            svg = picasso(text)
            svgCache.set(text, svg)
        }
        return {
            'background': `no-repeat url('data:image/svg+xml;utf8,${svg}')`,
            'background-size': 'cover'
        }
    }
}

const svgCache = new Map<string, string>()
